export const getAspect = (size?: [number, number]) => {
  if (!size) return;

  const [naturalWidth, naturalHeight] = size;
  if (!naturalWidth || !naturalHeight) return;

  return naturalHeight / naturalWidth;
};
